/* eslint-disable no-unused-vars */

import { Box, Tab, Tabs } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import { Separator } from 'components';
import * as S from './ChangingTabs.styled';

const ChangingTabs = ({ currentTab, handleChange, existing_audience, add_new_audience }) => {
  return (
    <TabContext value={currentTab}>
      <Box sx={{ width: '100%' }}>
        <S.MyBox>
          <S.MyTabs value={currentTab} onChange={handleChange}>
            <S.MyTab label='Existing audience' value='existing_audience' />
            <S.MyTab label='Add new audience' value='add_new_audience' />
          </S.MyTabs>
        </S.MyBox>
        <TabPanel value='existing_audience' index={0} sx={{ width: '100%', padding: '0' }}>
          {existing_audience}
        </TabPanel>
        <TabPanel value='add_new_audience' index={1} sx={{ width: '100%', padding: '0' }}>
          {add_new_audience}
        </TabPanel>
      </Box>
    </TabContext>
  );
};

export default ChangingTabs;
